package com.partejar.app.feature.home.presentation.components

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.semantics
import com.partejar.app.core.ui.components.PartejarCard
import com.partejar.app.core.ui.theme.PartejarIcons
import com.partejar.app.core.ui.theme.PartejarTheme
import com.partejar.app.feature.home.presentation.HomeAppointmentUi

@Composable
fun HomeTimeline(
    appointments: List<HomeAppointmentUi>,
    modifier: Modifier = Modifier
) {
    Column(modifier = modifier.fillMaxWidth()) {
        appointments.forEachIndexed { index, appointment ->
            HomeTimelineItem(
                appointment = appointment,
                isFirst = index == 0,
                isLast = index == appointments.lastIndex
            )
        }
    }
}

@Composable
private fun HomeTimelineItem(
    appointment: HomeAppointmentUi,
    isFirst: Boolean,
    isLast: Boolean
) {
    val spacing = PartejarTheme.spacing
    val dimensions = PartejarTheme.dimensions
    val lineColor = MaterialTheme.colorScheme.outline
    val dotColor = MaterialTheme.colorScheme.primary

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .heightIn(min = spacing.space64)
            .semantics(mergeDescendants = true) { },
        horizontalArrangement = Arrangement.spacedBy(spacing.space4),
        verticalAlignment = Alignment.Top
    ) {
        Canvas(
            modifier = Modifier.size(
                width = spacing.space20,
                height = spacing.space64
            )
        ) {
            val centerX = size.width / 2f
            val dotCenterY = spacing.space20.toPx()
            drawLine(
                color = lineColor,
                start = androidx.compose.ui.geometry.Offset(
                    centerX,
                    if (isFirst) dotCenterY else 0f
                ),
                end = androidx.compose.ui.geometry.Offset(
                    centerX,
                    if (isLast) dotCenterY else size.height
                ),
                strokeWidth = dimensions.strokeStrong.toPx()
            )
            drawCircle(
                color = dotColor,
                radius = spacing.space4.toPx(),
                center = androidx.compose.ui.geometry.Offset(centerX, dotCenterY)
            )
        }
        Row(
            modifier = Modifier.width(spacing.space64),
            horizontalArrangement = Arrangement.spacedBy(spacing.space4),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                imageVector = PartejarIcons.Clinical.schedule,
                contentDescription = null,
                modifier = Modifier.size(dimensions.iconSmall),
                tint = MaterialTheme.colorScheme.onSurfaceVariant
            )
            Text(
                text = appointment.time,
                style = MaterialTheme.typography.labelLarge,
                color = MaterialTheme.colorScheme.onSurface
            )
        }
        PartejarCard(
            modifier = Modifier.weight(1f),
            contentPadding = PaddingValues(spacing.space12)
        ) {
            Column(verticalArrangement = Arrangement.spacedBy(spacing.space4)) {
                Text(
                    text = appointment.relatedPerson,
                    style = MaterialTheme.typography.titleSmall
                )
                Text(
                    text = appointment.type,
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant
                )
            }
        }
    }
}
